import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const DiplomaMechanicalEngineeringCoursePage: React.FC = () => {
  const courseData = {
    title: "Diploma in Mechanical Engineering",
    shortName: "DME",
    duration: "3 years",
    description: "Comprehensive technical program covering mechanical systems, manufacturing, and industrial processes",
    overview: "Diploma in Mechanical Engineering is a 3-year technical program that provides practical knowledge and skills in mechanical systems, manufacturing processes, machine design, and industrial operations. This course combines theoretical learning with extensive hands-on training, preparing students for immediate employment in various industries as skilled technicians and junior engineers.",
    eligibility: [
      "10th pass from recognized board",
      "Minimum 50% marks in 10th (45% for SC/ST)",
      "Mathematics and Science as compulsory subjects",
      "Physical fitness for workshop activities"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Engineering Mathematics",
          "Engineering Physics",
          "Engineering Chemistry",
          "Engineering Drawing",
          "Workshop Technology",
          "Basic Mechanical Engineering"
        ]
      },
      {
        year: 2,
        subjects: [
          "Strength of Materials",
          "Thermodynamics",
          "Machine Drawing",
          "Manufacturing Technology",
          "Fluid Mechanics",
          "Material Science"
        ]
      },
      {
        year: 3,
        subjects: [
          "Machine Design",
          "Heat Transfer",
          "Production Technology",
          "Industrial Management",
          "Automobile Engineering",
          "Project Work & Industrial Training"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Mechanical Technician",
        "Production Supervisor",
        "Quality Control Inspector",
        "Maintenance Engineer",
        "Design Drafter",
        "Workshop Supervisor",
        "Field Service Engineer",
        "Machine Operator",
        "Tool Room Assistant",
        "Technical Sales Representative"
      ],
      industries: [
        "Manufacturing Industries",
        "Automobile Sector",
        "Power Plants",
        "Steel Industry",
        "Railway Workshops",
        "Defense Organizations",
        "Oil & Gas Companies",
        "Construction Equipment",
        "Machine Tool Industry",
        "HVAC Companies"
      ],
      averageSalary: "₹2.5-5 LPA (Fresher), ₹6-15 LPA (Experienced)",
      topRecruiters: [
        "Tata Motors, Mahindra",
        "L&T, BHEL, BEL",
        "Indian Railways",
        "ONGC, IOCL, NTPC",
        "Godrej, Bajaj Auto",
        "Maruti Suzuki, Hero MotoCorp"
      ]
    },

    admissionProcess: [
      "State Polytechnic Entrance Test",
      "Merit-based admission on 10th marks",
      "Counselling and seat allotment",
      "Document verification",
      "Fee payment and college reporting"
    ],

    topColleges: [
      {
        name: "Government Polytechnic College",
        location: "Chennai",
        fees: "₹15,000",
        ranking: "Government College"
      },
      {
        name: "PSG Polytechnic College",
        location: "Coimbatore",
        fees: "₹45,000",
        ranking: "Private - NAAC A+"
      },
      {
        name: "Thiagarajar Polytechnic College",
        location: "Salem",
        fees: "₹35,000",
        ranking: "Private - Autonomous"
      },
      {
        name: "Government Polytechnic",
        location: "Madurai",
        fees: "₹18,000",
        ranking: "Government College"
      }
    ],

    skills: [
      "CAD/CAM Software",
      "Manufacturing Processes",
      "Quality Control Methods",
      "Machine Operation",
      "Technical Drawing",
      "Workshop Practices",
      "Maintenance Techniques",
      "Problem Solving",
      "Safety Protocols",
      "Project Management"
    ],

    futureScope: "Excellent opportunities in automation, robotics, renewable energy, and advanced manufacturing with Industry 4.0 creating demand for skilled mechanical technicians.",

    faqs: [
      {
        question: "Can I pursue B.Tech after Diploma in Mechanical Engineering?",
        answer: "Yes, you can pursue B.Tech through lateral entry (direct 2nd year admission) in Mechanical Engineering or related branches in most engineering colleges."
      },
      {
        question: "What is the difference between ITI and Diploma in Mechanical?",
        answer: "ITI is skill-focused training (6 months-2 years) while Diploma is more comprehensive technical education (3 years) with broader career opportunities and higher education prospects."
      },
      {
        question: "Are there government job opportunities for diploma holders?",
        answer: "Yes, many government organizations like Railways, PSUs, defense establishments, and state government departments recruit diploma holders for technical positions."
      },
      {
        question: "What are the entrepreneurship opportunities?",
        answer: "Diploma graduates can start manufacturing units, service centers, consultancy firms, or become dealers for industrial equipment with their technical knowledge."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0a183d] via-black to-[#1a2746] flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow animate-glow mb-8 text-center">
        {courseData.title}
      </h1>
      <div className="w-full max-w-5xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default DiplomaMechanicalEngineeringCoursePage;
